'use strict';

(function () {
  angular
    .module('specsguardApp')
    .controller('ProjectLocationCtrl', ProjectLocationCtrl);

  ProjectLocationCtrl.$inject = ['$scope', 'Project', 'Auth', 'Utils', 'errorMessageService',
    'ProjectDataservice', 'Labels', '$injector'];

  function ProjectLocationCtrl ($scope, Project, Auth, Utils, errorMessageService,
    ProjectDataservice, Labels, $injector) {

    const vm = this;

    $scope.LABELS = Labels;

    vm.$onInit = function () {
      vm.canWrite = Utils.isUserManager(Auth, vm.project);

      setTimeout(() => {
        $scope.sg2AuthService = $injector.get('sg2AuthService');
      }, 100);
    };

    vm.submit = function () {
      if (vm.projectForm.$dirty) {

        const project = {
          address: vm.project.address,
          zipcode: vm.project.zipcode,
          city: vm.project.city,
          country: vm.project.country,
        };

        const version = {
          info: vm.project.info,
        };

        // @ts-ignore
        var geocoder = new google.maps.Geocoder();

        var geocodeAddress = function (proj) {
          return new Promise((resolve) => {
            if (!proj.address) {
              resolve();
            }
            geocoder.geocode({
              address: `${proj.address}, ${proj.zipcode}, ${proj.city}`
            }, (results, status) => {
              if (status === 'OK') {
                var location = results[0].geometry.location;
                resolve({
                  lat: location.lat(),
                  lng: location.lng()
                });
              } else {
                // Overwrite db values with null when location is unknown/deleted.
                resolve({
                  lat: null,
                  lng: null
                });
              }
            });
          });
        };

        geocodeAddress(project)
          .then((location) => {
            // @ts-ignore 
            project.lat = location && location.lat || null;
            // @ts-ignore
            project.lng = location && location.lng || null;

            Project.editProject({
              project,
              version,
              versionId: vm.project.versionId,
              _id: vm.project._id
            })
              .$promise
              .then((updatedProj) => {
                errorMessageService.showSuccess($scope.LABELS.getLabel('projectinformationupdated'));
                ProjectDataservice.setProjectById(updatedProj._id, updatedProj);
                vm.updateProject({project: updatedProj});
              });
          });

      }
    };

  }
})();
